module.exports = __webpack_public_path__ + "img/data-driven-marketing.b1423717.svg";